import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';


import { FestivoIndexComponent } from './FestivoIndex.component';
import { DialogConfirmacion } from './FestivoIndex.component';

import { RoleGuardService as RoleGuard } from '../Seguridad/role-guard.service';

const routes = [
    {
        path     : 'RegistrarFestivos',
        component: FestivoIndexComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'RegistrarFestivos',
          nombreFormulario : 'RegistrarFestivos'
        } 
    }
];

@NgModule({
    declarations: [
        FestivoIndexComponent,
        DialogConfirmacion
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        FestivoIndexComponent,
    ],
    bootstrap: [FestivoIndexComponent, DialogConfirmacion],
})

export class FestivoModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/RegistrarFestivos/Festivo.module.ts